import { themeBalham } from "ag-grid-enterprise";

export const themeSelector = themeBalham.withParams({
  fontFamily: "var(--font)",
  fontSize: 14,
  // accentColor: "var(--primary-main)",
  foregroundColor: "var(--text-default)",
  backgroundColor: "white",
  headerBackgroundColor: "var(--header-background)",
  borderColor: "var(--ui-border)",
  invalidColor: "var(--danger-main)",
  rowHeight: 32,
  iconSize: 16,
  inputHeight: 30,
  borderRadius: 2,
  borderWidth: 1,
  headerColumnBorderHeight: "100%",

  /* Headers */
  headerHeight: 27,
  headerVerticalPaddingScale: 0,
  cellHorizontalPadding: 5,

  /* Checkboxes */
  checkboxBorderRadius: 3,

  checkboxUncheckedBackgroundColor: "var(--light-background)",
  checkboxUncheckedBorderColor: "var(--form-input-border)",

  checkboxBorderWidth: 1,

  checkboxCheckedBackgroundColor: "var(--primary-main)",
  checkboxCheckedBorderColor: "var(--primary-main)",
  checkboxCheckedShapeColor: "var(--light-background)",

  checkboxIndeterminateBorderColor: "var(--form-input-border)",
});
